import type { ReactNode } from "react";
import styles from "./SettingsField.module.scss";
import { combineClasses } from "@/lib/utils";

export interface SettingsFieldProps {
  label: string;
  htmlFor?: string;
  hint?: string;
  className?: string;
  children: ReactNode;
}

const SettingsField = ({
  label,
  htmlFor,
  hint,
  className = "",
  children,
}: SettingsFieldProps) => {
  return (
    <div className={combineClasses(styles.fieldGroup, className)}>
      <label className={styles.fieldLabel} htmlFor={htmlFor}>
        {label}
      </label>
      {children}
      {hint && <span className={styles.fieldHint}>{hint}</span>}
    </div>
  );
};

export default SettingsField;
